export default [
  {
    name: 'monitoringManagement',
    label: 'labels.monitoringManagement',
    permissionKey: 'monitoring_management',
    children: [
      {
        name: 'monitoring_internal',
        label: 'labels.monitoringInternal',
        permissionKey: 'monitoring_internal'
      },
      {
        name: 'monitoring_partner',
        label: 'labels.monitoringPartner',
        permissionKey: 'monitoring_partner'
      },
      {
        name: 'monitoring_journey_pricing_view',
        label: 'labels.viewJourneyPrices',
        permissionKey: 'monitoring_journey_pricing_view'
      },
      {
        name: 'monitoring_journey_pricing_edit',
        label: 'labels.editJourneyPrices',
        permissionKey: 'monitoring_journey_pricing_edit'
      }
    ]
  }
]
